// For the TimeZone selects we need to keep in sync (both mobile and desktop versions) we're not using a conventional select tags. We're using our DropdownSelectComponent.
// That means each "Select" option is a li tag with a data-value attribute. Normal select tag behavior is not available.
// If the user is in the mobile version, once he clicks (selects) a new option (time-zone), we can trigger a click in the same option in the desktop version,
// letting the component handle the rest.
//
// If the click happens in the desktop version, we don't need to "click" the mobile dropdown/select. We can simply change values/texts,
// since the change in the desktop version is what actually triggers the changes/updates needed in the calendar.

const findCurrentOption = (optionNodes, currentValue) => {
  return Array.from(optionNodes).find(
    (option) => option.dataset.value === currentValue
  )
}

const findAndClickOption = (optionNodes, currentValue) => {
  const option = findCurrentOption(optionNodes, currentValue)
  if (option) {
    option.dispatchEvent(new Event('click'))
  }
}

export const syncMobileAndDesktopTimezoneSelects = ({
  mobileSelect,
  mobileSelectOpener,
  desktopSelect,
  desktopSelectOptions,
}) => {
  mobileSelect.value = desktopSelect.value

  mobileSelect.addEventListener('change', () => {
    findAndClickOption(desktopSelectOptions, mobileSelect.value)
  })

  const updateMobileTzBasedOnDesktop = () => {
    const currentOption = findCurrentOption(
      desktopSelectOptions,
      desktopSelect.value
    )
    if (currentOption) {
      mobileSelect.value = currentOption.dataset.value
      mobileSelectOpener.dataset.value = currentOption.dataset.value
      mobileSelectOpener.querySelector('.t-btn-main-label').textContent =
        currentOption.textContent
    }
  }

  desktopSelect.addEventListener('change', () => {
    updateMobileTzBasedOnDesktop()
  })

  updateMobileTzBasedOnDesktop()
}
